import api from './api';

export const listLogs = async ({ kind, limit = 50, before } = {}) => {
  const params = new URLSearchParams();
  if (kind) params.set('kind', kind);
  if (limit) params.set('limit', String(limit));
  if (before) params.set('before', before);
  const { data } = await api.get(`/logs?${params.toString()}`);
  return data.items;
};

export const getLog = async (id) => {
  const { data } = await api.get(`/logs/${id}`);
  return data.item;
};
